import Vue from 'vue'
import emptyPage from '../biz/common-page/empty-page'
import listBottom from '../biz/common-page/list-bottom'

export default function install () {
  Vue.component('empty-page', emptyPage)
  Vue.component('list-bottom', listBottom)
}
